<template>
  <base-floating-card @close="close">
    <div id="event-remove-contact-card">
      <remove-location-from-event-art class="art" />
      <div id="heading-and-buttons">
        <h5 id="remove-contact-heading">
          Remove {{ contactName }} from this event?
        </h5>
        <div id="remove-contact-buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="confirm"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import RemoveLocationFromEventArt from "../../Illustrations/RemoveContactFromEvent.vue";

export default {
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    contactName() {
      if (this.contact) {
        return `${this.contact.given_name} ${this.contact.family_name}`;
      } else {
        return "this contact";
      }
    },
  },
  methods: {
    close() {
      if (!this.processing) {
        this.$emit("close");
      }
    },
    async confirm() {
      this.processing = true;
      await this.$store.dispatch("removeContactFromEvent", this.contact);
      this.processing = false;
      this.close();
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    RoundButtonWithIcon,
    RemoveLocationFromEventArt,
  },
  emits: ["close"],
  props: ["contact", "event"],
};
</script>
<style scoped>
#event-remove-contact-card {
  display: flex;
  justify-content: space-between;
  padding: 50px;
}

.art {
  height: 75px;
  margin-right: 70px;
}

#heading-and-buttons {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#remove-contact-buttons {
  display: flex;
  width: 100px;
  justify-content: space-between;
}
</style>
